<div class="error-server-container" *ngIf="!isRapidScore">
    <div class="header">

    </div>
    <div class="left">
        <div class="container-left">
            <p class="close"><img src="./assets/logos/close.svg" (click)="close()" alt=""></p>
            <div class="alert"><img src="./assets/temporals/warning.png" alt=""></div>
            <div class="text-information">Ops… no hemos podido conectar con tu banco</div>
            <button *ngIf="!hideTryButton" (click)="close()" id="againTry" type="submit">Volver a intentar</button>
        </div>
    </div>
    <div class="right">
        <div class="imgs-container">
            <img class="oval" src="./assets/temporals/thinking_boy.svg" alt="">
        </div>
    </div>
    <div class="footer">
        <button *ngIf="!hideTryButton" (click)="close()" id="againTry" type="submit">Volver a intentar</button>
    </div>
</div>
<div class="error-server-container-rapidScore" *ngIf="isRapidScore">
    <header  class="header" *ngIf="headerFooter">
        <div class="container-logo">
          <div class="logo"><img
              src="{{ './assets/logos/Logo_SCF_red.png' }}"
              [ngStyle]="{'cursor': 'auto', 'width':  '130px', 'padding': '0'}" alt="Logo_SCF_red"></div>
        </div>
      </header>
      <div class="body">
        <img src="./assets/login/error-server-rapidScore.png" alt="error-server-rapidScore">
        <div class="message">
            <strong>
                Ops...!
            </strong>
            <br>
            <p>
                No hemos podido conectar con tu banco.
            </p>
            <button *ngIf="!hideTryButton" (click)="close()" id="againTry" type="submit">Volver a intentar</button>
        </div>
      </div>
</div>